import validator from "validator";
import { parseStringValue } from "../parse-string-value.js";
const { isStrongPassword } = validator;
export function passwordField(opts) {
    return (value) => {
        const res = parseStringValue(value, opts);
        if (!res.isValid || !res.value)
            return res;
        if (!isStrongPassword(res.value)) {
            return {
                isValid: false,
                error: opts.message,
            };
        }
        return {
            isValid: true,
            value: res.value,
        };
    };
}
